import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { createUseStyles } from "react-jss";
import { useState } from "react";
import ArrowLeftSLineIcon from "remixicon-react/ArrowLeftSLineIcon";
import ArrowRightSLineIcon from "remixicon-react/ArrowRightSLineIcon";
import { theme } from "$utils/theme/bataillog";
import sections from "./sections";

type Props = {
  onItemClick: (id: string) => void;
};

function Navigation({ onItemClick }: Props) {
  const classes = useStyles();
  const [showTexts, setShowTexts] = useState(true);
  return (
    <List className={classes.list}>
      <ListItem button onClick={() => setShowTexts(!showTexts)}>
        <ListItemIcon className={classes.icon}>
          {showTexts ? <ArrowRightSLineIcon /> : <ArrowLeftSLineIcon />}
        </ListItemIcon>

        {showTexts && (
          <ListItemText
            primary="NAVIGATION"
            primaryTypographyProps={{
              style: { fontWeight: "bold", textAlign: "center" },
            }}
          />
        )}
      </ListItem>
      {sections.map((section) => (
        <ListItem
          key={section.id}
          button
          className={classes.item}
          onClick={() => onItemClick(section.id)}
        >
          <ListItemIcon className={classes.icon}>{section.icon}</ListItemIcon>
          {showTexts && <ListItemText primary={section.label} />}
        </ListItem>
      ))}
    </List>
  );
}

export default Navigation;

const useStyles = createUseStyles(() => ({
  list: {
    backgroundColor: theme.color.gray1,
    marginRight: `${theme.spacing(3)}px !important`,
    padding: `${0} !important`,
    position: "fixed !important",
    right: 0,
    top: "128px",
    width: "fit-content",
    zIndex: 3, // make it above selectors and tables
  },
  item: {
    flex: 0,
  },
  icon: {
    marginRight: theme.spacing(1),
    minWidth: "auto !important",
  },
}));
